<template>
  <!-- Giriş ve SSO ekranlarının kabuğu: üstte logo, ≥992px solda illüstrasyon + tanıtım, sağda form kartı.
       Görünüm assets/css/auth.css. -->
  <div class="vega-auth">
    <header class="vega-auth__top">
      <img :src="logo" class="vega-auth__logo" alt="Vega">
    </header>
    <main v-if="ready" class="vega-auth__main">
      <section class="vega-auth__intro">
        <img :src="illustration" class="vega-auth__illustration" alt="">
        <!-- Anahtar Translation tablosuna senkronlanana kadar ham anahtar yerine hiçbir şey gösterilmez. -->
        <p v-if="$te('VegaLoginIntro')" class="vega-auth__intro-text">{{ $t('VegaLoginIntro') }}</p>
      </section>
      <div class="vega-auth__card">
        <router-view></router-view>
      </div>
    </main>
    <div v-else class="vega-auth__main" aria-busy="true"></div>
    <footer class="vega-auth__foot">© {{ year }} Softage Yazılım A.Ş.</footer>
  </div>
</template>
<script>
  import logo from '../assets/images/logo-wordmark-teal.png'
  // unDraw "medicine" (lisans: ticari kullanım serbest, atıf gerekmez); ana renk Vega teal'ine çevrildi.
  import illustration from '../assets/images/login/clinic-team.svg'
  import { translationsLoaded } from '../i18n'

  // Çeviri isteği takılırsa form en geç bu süre sonra ham anahtarlarla da olsa açılır.
  const TRANSLATION_WAIT_MS = 4000

  export default {
    name: 'AuthLayout',
    data() {
      return {
        logo: logo,
        illustration: illustration,
        year: new Date().getFullYear(),
        waitedTooLong: false
      }
    },
    computed: {
      ready() {
        return translationsLoaded.value || this.waitedTooLong
      }
    },
    mounted() {
      if (!translationsLoaded.value) this.waitTimer = setTimeout(() => { this.waitedTooLong = true }, TRANSLATION_WAIT_MS)
    },
    beforeUnmount() {
      clearTimeout(this.waitTimer)
    }
  }
</script>

<style src="../assets/css/auth.css"></style>
